import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/cnd/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

export async function findCNDTipo(empresa_cnpj) {
  const headers = new Headers();
  headers.append("Authorization", token);

  return search(path, "GET", headers);
}
